export default __webpack_public_path__ + "static/media/third-off.20c65854.png";